<template>
  <div class="s_bf box" :style="'margin:'+(data.style.paddingTB*0.9)+'px '+(data.style.paddingLR*0.9) +'px;'">
    <div class="heade" v-if='data.params.show'>
      <div class="headeTitle s_flex_center p-t-5">
        <img src="@/assets/images/integralShop/hot.png" alt="">
        <p class="fz-15 s_font_b m-l-5">{{data.params.goodTitle}}</p>
      </div>
    </div>
    <div class='goods'>
      <div v-for="count  in 4" :key="count">
        <img src="@/assets/images/normal.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
  import * as Icon from "@ant-design/icons-vue";
  export default {
    props: { data: Object },
    components: { ...Icon },
    name: "goods"
  }
</script>
<style lang="less" scoped>
  .box {
    border-radius: 10px;
    padding: 10px
  }

  .heade {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: #000;
    margin-bottom: 10px;

    .headeTitle {
      width: 100%;

      img {
        width: 25px;
        display: block;
      }
    }

    .headeRight {
      font-size: 12px;
    }
  }

  .goods {
    white-space: nowrap;
    overflow-y: hidden;
    overflow-x: scroll;
    max-width: 100%;

    >div {
      width: 125px;
      height: 85px;
      display: inline-block;
      font-size: 12px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-right: 8px;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
</style>